import {useQuantity} from "./useQuantity";

export const useMinimumQuantityNotice = (minimumQuantity: number) => {
    const {displayQuantity} = useQuantity();
    return {
        displayQuantity,
        className: `${displayQuantity >= minimumQuantity ? 'text-muted' : 'text-danger'} d-block mt-2 ms-1`
    };
}